import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from 'tradera-lang/translate';
import CheckIcon from '@tradera/blueprint/theme/icons2/check.svg?jsx';
import LoadingIcon from '@tradera/blueprint/theme/icons2/loading.svg?jsx';

export const SubmitButton = ({
    isInMultipleFeedbacksContext,
    isSubmitting,
    onClick,
    submittableCount,
    className = ''
}) => {
    const { t } = useTranslator();
    const submitButtonText = isInMultipleFeedbacksContext
        ? t(
              submittableCount > 0
                  ? 'leaveFeedback_submitButton'
                  : 'leaveFeedback_submitButton_noSelected',
              {
                  count: submittableCount
              }
          )
        : t('leaveFeedback_confirmButton');
    return (
        <button
            className={`btn btn-primary ${className}`}
            onClick={onClick}
            disabled={isSubmitting || submittableCount === 0}>
            {isSubmitting ? (
                <LoadingIcon
                    className={`icon icon-spin icon-sm icon-white mr-1`}
                />
            ) : (
                <CheckIcon className={`icon icon-sm icon-white mr-1`} />
            )}

            {submitButtonText}
        </button>
    );
};

SubmitButton.propTypes = {
    isInMultipleFeedbacksContext: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    submittableCount: PropTypes.number.isRequired,
    className: PropTypes.string
};
